import { render, staticRenderFns } from "./FileDuplicate.vue?vue&type=template&id=d6331b58&"
import script from "./FileDuplicate.vue?vue&type=script&lang=ts&"
export * from "./FileDuplicate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports